// As strings do voucher aéreo novo (`buildFlightVoucherView`, Figma "Flight-emitido v2"),
// em arquivo próprio: o catálogo principal já passa das 380 linhas e o teto é 500. O
// `CATALOG` espalha estas três por cima das dele.
const PT_BR = {
  'trips.flightVoucher.title': 'Aéreo',
  'trips.flightVoucher.strip.requested': 'Solicitado',
  'trips.flightVoucher.strip.awaitingApproval': 'Em aprovação',
  'trips.flightVoucher.strip.issuing': 'Em emissão',
  'trips.flightVoucher.strip.issued': 'Emitido',
  'trips.flightVoucher.strip.declined': 'Recusado',
  'trips.flightVoucher.requestedOn': 'Solicitado em {{date}}',
  'trips.flightVoucher.issuedOn': 'Emitido em {{date}}',
  'trips.flightVoucher.canceledOn': 'Cancelado em {{date}}',
  'trips.flightVoucher.stopAt': '{{wait}} em {{code}}',
  'trips.flightVoucher.changePlane': 'troca de aeronave',
  'trips.flightVoucher.carryOnIncluded': 'Bagagem de mão incluída',
  'trips.flightVoucher.total': 'Total',
  'trips.flightVoucher.requestedAt': 'Solicitado em',
  'trips.flightVoucher.retry': 'Pedir de novo',
  'trips.flightVoucher.requote': 'Cotar novamente',
  'trips.flightVoucher.copyLocator': 'o localizador deste trecho',
  'trips.flightVoucher.legCancelled': 'Cancelado',
  'trips.flightVoucher.extra.seatUnmarked': 'Não marcado · Marcação paga',
  'trips.flightVoucher.extra.checked': 'Bagagem despachada',
  'trips.flightVoucher.extra.checkedIncluded': 'Incluída na tarifa',
  'trips.flightVoucher.extra.checkedPieces_one': '{{count}} volume incluído na tarifa',
  'trips.flightVoucher.extra.checkedPieces_other': '{{count}} volumes incluídos na tarifa',
  'trips.flightVoucher.extra.checkedPiecesKg_one': '{{count}} × {{kg}} kg incluída na tarifa',
  'trips.flightVoucher.extra.checkedPiecesKg_other': '{{count}} × {{kg}} kg incluídas na tarifa',
  'trips.flightVoucher.extra.checkedNone': 'Não inclusa na tarifa',
  'trips.flightVoucher.extra.carryNone': 'Só item pessoal incluído',
  'trips.flightVoucher.scope.oneWay': 'Só ida · {{route}}',
  'trips.flightVoucher.scope.roundTrip': 'Ida e volta · {{route}}',
  'trips.flightVoucher.scope.multi': 'Múltiplos destinos · {{route}}',
  'trips.flightVoucher.scope.legs': '{{count}} trechos',
  'trips.flightVoucher.dates.one': 'Voo · {{date}}',
  'trips.flightVoucher.dates.many': 'Voos · {{range}}',
  'trips.flightVoucher.requestedBy': 'Solicitado por',
  'trips.flightVoucher.canceledBy': 'Cancelado por',
  'trips.flightVoucher.policy': 'Política',
  'trips.flightVoucher.policyExceptions_one': '{{count}} exceção',
  'trips.flightVoucher.policyExceptions_other': '{{count}} exceções',
  'trips.flightVoucher.approvals': 'Aprovações',
  'trips.flightVoucher.approvalsPending': 'Pendente · {{names}}',
  'trips.flightVoucher.awaitingApprovalNotice': 'Aguardando aprovação de {{names}}.',
  'trips.flightVoucher.expiresOn': 'Expira {{date}}',
  'trips.flightVoucher.fareGuaranteed':
    'Tarifa garantida até {{date}}; depois disso o valor pode mudar.',
  'trips.flightVoucher.approvedBy': 'Aprovado por {{names}}',
  'trips.flightVoucher.fare': 'Tarifa',
  'trips.flightVoucher.fees': 'Taxas e encargos',
  'trips.flightVoucher.rule.CHANGE.included': 'Remarcação incluída',
  'trips.flightVoucher.rule.CHANGE.charged': 'Remarcação com custo',
  'trips.flightVoucher.rule.CHANGE.blocked': 'Remarcação não permitida',
  'trips.flightVoucher.rule.REFUND.included': 'Reembolsável',
  'trips.flightVoucher.rule.REFUND.charged': 'Reembolso com custo',
  'trips.flightVoucher.rule.REFUND.blocked': 'Não reembolsável',
  'trips.flightVoucher.rule.CANCELLATION.included': 'Cancelamento incluído',
  'trips.flightVoucher.rule.CANCELLATION.charged': 'Cancelamento com custo',
  'trips.flightVoucher.rule.CANCELLATION.blocked': 'Cancelamento não permitido',
};

const EN: Record<keyof typeof PT_BR, string> = {
  'trips.flightVoucher.title': 'Flight',
  'trips.flightVoucher.strip.requested': 'Requested',
  'trips.flightVoucher.strip.awaitingApproval': 'Awaiting approval',
  'trips.flightVoucher.strip.issuing': 'Being issued',
  'trips.flightVoucher.strip.issued': 'Issued',
  'trips.flightVoucher.strip.declined': 'Declined',
  'trips.flightVoucher.requestedOn': 'Requested on {{date}}',
  'trips.flightVoucher.issuedOn': 'Issued on {{date}}',
  'trips.flightVoucher.canceledOn': 'Canceled on {{date}}',
  'trips.flightVoucher.stopAt': '{{wait}} in {{code}}',
  'trips.flightVoucher.changePlane': 'aircraft change',
  'trips.flightVoucher.carryOnIncluded': 'Carry-on included',
  'trips.flightVoucher.total': 'Total',
  'trips.flightVoucher.requestedAt': 'Requested on',
  'trips.flightVoucher.retry': 'Request again',
  'trips.flightVoucher.requote': 'Get a new quote',
  'trips.flightVoucher.copyLocator': 'this leg’s locator',
  'trips.flightVoucher.legCancelled': 'Cancelled',
  'trips.flightVoucher.extra.seatUnmarked': 'Not chosen · Paid selection',
  'trips.flightVoucher.extra.checked': 'Checked bag',
  'trips.flightVoucher.extra.checkedIncluded': 'Included in the fare',
  'trips.flightVoucher.extra.checkedPieces_one': '{{count}} bag included in the fare',
  'trips.flightVoucher.extra.checkedPieces_other': '{{count}} bags included in the fare',
  'trips.flightVoucher.extra.checkedPiecesKg_one': '{{count}} × {{kg}} kg included in the fare',
  'trips.flightVoucher.extra.checkedPiecesKg_other': '{{count}} × {{kg}} kg included in the fare',
  'trips.flightVoucher.extra.checkedNone': 'Not included in the fare',
  'trips.flightVoucher.extra.carryNone': 'Personal item only',
  'trips.flightVoucher.scope.oneWay': 'One way · {{route}}',
  'trips.flightVoucher.scope.roundTrip': 'Round trip · {{route}}',
  'trips.flightVoucher.scope.multi': 'Multi-city · {{route}}',
  'trips.flightVoucher.scope.legs': '{{count}} legs',
  'trips.flightVoucher.dates.one': 'Flight · {{date}}',
  'trips.flightVoucher.dates.many': 'Flights · {{range}}',
  'trips.flightVoucher.requestedBy': 'Requested by',
  'trips.flightVoucher.canceledBy': 'Canceled by',
  'trips.flightVoucher.policy': 'Policy',
  'trips.flightVoucher.policyExceptions_one': '{{count}} exception',
  'trips.flightVoucher.policyExceptions_other': '{{count}} exceptions',
  'trips.flightVoucher.approvals': 'Approvals',
  'trips.flightVoucher.approvalsPending': 'Pending · {{names}}',
  'trips.flightVoucher.awaitingApprovalNotice': 'Awaiting approval from {{names}}.',
  'trips.flightVoucher.expiresOn': 'Expires {{date}}',
  'trips.flightVoucher.fareGuaranteed':
    'Fare guaranteed until {{date}}; after that the price may change.',
  'trips.flightVoucher.approvedBy': 'Approved by {{names}}',
  'trips.flightVoucher.fare': 'Fare',
  'trips.flightVoucher.fees': 'Taxes and fees',
  'trips.flightVoucher.rule.CHANGE.included': 'Changes included',
  'trips.flightVoucher.rule.CHANGE.charged': 'Changes for a fee',
  'trips.flightVoucher.rule.CHANGE.blocked': 'No changes allowed',
  'trips.flightVoucher.rule.REFUND.included': 'Refundable',
  'trips.flightVoucher.rule.REFUND.charged': 'Refund for a fee',
  'trips.flightVoucher.rule.REFUND.blocked': 'Non-refundable',
  'trips.flightVoucher.rule.CANCELLATION.included': 'Cancellation included',
  'trips.flightVoucher.rule.CANCELLATION.charged': 'Cancellation for a fee',
  'trips.flightVoucher.rule.CANCELLATION.blocked': 'No cancellation allowed',
};

const ES: Record<keyof typeof PT_BR, string> = {
  'trips.flightVoucher.title': 'Aéreo',
  'trips.flightVoucher.strip.requested': 'Solicitado',
  'trips.flightVoucher.strip.awaitingApproval': 'En aprobación',
  'trips.flightVoucher.strip.issuing': 'En emisión',
  'trips.flightVoucher.strip.issued': 'Emitido',
  'trips.flightVoucher.strip.declined': 'Rechazado',
  'trips.flightVoucher.requestedOn': 'Solicitado el {{date}}',
  'trips.flightVoucher.issuedOn': 'Emitido el {{date}}',
  'trips.flightVoucher.canceledOn': 'Cancelado el {{date}}',
  'trips.flightVoucher.stopAt': '{{wait}} en {{code}}',
  'trips.flightVoucher.changePlane': 'cambio de avión',
  'trips.flightVoucher.carryOnIncluded': 'Equipaje de mano incluido',
  'trips.flightVoucher.total': 'Total',
  'trips.flightVoucher.requestedAt': 'Solicitado el',
  'trips.flightVoucher.retry': 'Pedir de nuevo',
  'trips.flightVoucher.requote': 'Cotizar de nuevo',
  'trips.flightVoucher.copyLocator': 'el localizador de este tramo',
  'trips.flightVoucher.legCancelled': 'Cancelado',
  'trips.flightVoucher.extra.seatUnmarked': 'Sin marcar · Selección paga',
  'trips.flightVoucher.extra.checked': 'Equipaje facturado',
  'trips.flightVoucher.extra.checkedIncluded': 'Incluido en la tarifa',
  'trips.flightVoucher.extra.checkedPieces_one': '{{count}} maleta incluida en la tarifa',
  'trips.flightVoucher.extra.checkedPieces_other': '{{count}} maletas incluidas en la tarifa',
  'trips.flightVoucher.extra.checkedPiecesKg_one': '{{count}} × {{kg}} kg incluida en la tarifa',
  'trips.flightVoucher.extra.checkedPiecesKg_other': '{{count}} × {{kg}} kg incluidas en la tarifa',
  'trips.flightVoucher.extra.checkedNone': 'No incluido en la tarifa',
  'trips.flightVoucher.extra.carryNone': 'Solo artículo personal',
  'trips.flightVoucher.scope.oneWay': 'Solo ida · {{route}}',
  'trips.flightVoucher.scope.roundTrip': 'Ida y vuelta · {{route}}',
  'trips.flightVoucher.scope.multi': 'Varios destinos · {{route}}',
  'trips.flightVoucher.scope.legs': '{{count}} tramos',
  'trips.flightVoucher.dates.one': 'Vuelo · {{date}}',
  'trips.flightVoucher.dates.many': 'Vuelos · {{range}}',
  'trips.flightVoucher.requestedBy': 'Solicitado por',
  'trips.flightVoucher.canceledBy': 'Cancelado por',
  'trips.flightVoucher.policy': 'Política',
  'trips.flightVoucher.policyExceptions_one': '{{count}} excepción',
  'trips.flightVoucher.policyExceptions_other': '{{count}} excepciones',
  'trips.flightVoucher.approvals': 'Aprobaciones',
  'trips.flightVoucher.approvalsPending': 'Pendiente · {{names}}',
  'trips.flightVoucher.awaitingApprovalNotice': 'Esperando la aprobación de {{names}}.',
  'trips.flightVoucher.expiresOn': 'Vence {{date}}',
  'trips.flightVoucher.fareGuaranteed':
    'Tarifa garantizada hasta {{date}}; después el valor puede cambiar.',
  'trips.flightVoucher.approvedBy': 'Aprobado por {{names}}',
  'trips.flightVoucher.fare': 'Tarifa',
  'trips.flightVoucher.fees': 'Tasas y cargos',
  'trips.flightVoucher.rule.CHANGE.included': 'Cambios incluidos',
  'trips.flightVoucher.rule.CHANGE.charged': 'Cambios con costo',
  'trips.flightVoucher.rule.CHANGE.blocked': 'Cambios no permitidos',
  'trips.flightVoucher.rule.REFUND.included': 'Reembolsable',
  'trips.flightVoucher.rule.REFUND.charged': 'Reembolso con costo',
  'trips.flightVoucher.rule.REFUND.blocked': 'No reembolsable',
  'trips.flightVoucher.rule.CANCELLATION.included': 'Cancelación incluida',
  'trips.flightVoucher.rule.CANCELLATION.charged': 'Cancelación con costo',
  'trips.flightVoucher.rule.CANCELLATION.blocked': 'Cancelación no permitida',
};

export const FLIGHT_VOUCHER_CATALOG = { 'pt-BR': PT_BR, en: EN, es: ES };
